export const defaultFormatter = (num, option, country) =>
  new Intl.NumberFormat(country || 'en-US', option || {}).format(num || 0);
